'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

type ReadMoreProps = {
  children: string;
  maxSize?: number;
};

export default function ReadMore({
  children: text,
  maxSize = 300,
}: ReadMoreProps) {
  const t = useTranslations('general');
  const [isReadMore, setIsReadMore] = useState(false);

  const truncatedText = text.length > maxSize ? text.slice(0, maxSize) : text;
  const hiddenText =
    text.length > maxSize ? text.slice(maxSize, text.length) : '';

  const handleReadMoreClicked = () => {
    setIsReadMore((prevValue) => !prevValue);
  };

  return (
    <>
      <p className="hidden lg:block">{text}</p>
      <p className="block lg:hidden">
        {truncatedText}
        {hiddenText && !isReadMore && '...'}
        {hiddenText && isReadMore && hiddenText}
      </p>
      {hiddenText && (
        <button
          className="mt-2 underline cursor-pointer lg:hidden text-teal-40 "
          onClick={handleReadMoreClicked}
        >
          {isReadMore ? t('read-less') : t('read-more')}
        </button>
      )}
    </>
  );
}
